import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export const initIntegrationsSlider = () => {
  const sliders = document.querySelectorAll(
    '[data-pro-multifamily-overview-integrations-slider]'
  );

  const setOptions = (direction) => ({
    type: 'loop',
    direction,
    autoWidth: true,
    drag: 'free',
    gap: 20,
    arrows: false,
    pagination: false,
    autoScroll: {
      speed: 0.5,
    },
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
    },
    breakpoints: {
      1024: {
        gap: 15,
      },
    },
  });

  const REDUCED_MOTION_MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
  const isReducedAnimation = window.matchMedia(
    REDUCED_MOTION_MEDIA_QUERY
  ).matches;

  sliders.forEach((slider, index) => {
    let direction = 'ltr';

    if ((index + 1) % 2 !== 0) {
      direction = 'rtl';
    }
    const options = setOptions(direction);
    const splide = new Splide(slider, options);

    if (isReducedAnimation) {
      splide.mount();
    } else {
      splide.mount({ AutoScroll });
    }
  });
};
